import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/checklist-templates",
};
export const checklistTemplatesService = {
    getChecklistTemplates: (page, pageSize) => {
        const params = new URLSearchParams();
        if (page != null)
            params.append("Page", page.toString());
        if (pageSize != null)
            params.append("PageSize", pageSize.toString());
        const query = params.toString();
        return apiClient.get(query ? `${ENDPOINTS.LIST}?${query}` : ENDPOINTS.LIST);
    },
    createChecklistTemplate: (payload) => apiClient.post(ENDPOINTS.LIST, payload),
    updateChecklistTemplate: (id, payload) => apiClient.put(`${ENDPOINTS.LIST}/${id}`, payload),
    deleteChecklistTemplate: (id) => apiClient.delete(`${ENDPOINTS.LIST}/${id}`),
};
